import React, { FC, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Step, StepLabel, Stepper, CircularProgress } from '@material-ui/core'
import ActionData from '../../../types/ActionData'
import GeneralInfo from '../../LocationApplicationDashboard/LocationApplication/GeneralInfo'
import ContactInfo from '../../LocationApplicationDashboard/LocationApplication/ContactInfo'


import { mainColors } from '../../../assets/colors'
import './index.css'
import Organization from '../../../types/Organization'

// interface OrganizationBilling {
//   firstName: string;
//   lastName: string;
//   emailAddress: string;
//   address1: string;
//   address2: string;
//   countyId: number;
//   city: string;
//   state: string;
//   zipCode: string;
// }

interface Props {
  show: boolean;
  applicationType: string;
  updatingLocationApplicationForm: boolean;
  generalInfoState: any;
  updateGeneralInfo: ActionData;
  // organizationBillingState: any;
  // updateLocationApplicationGeneralInfo: ActionData;
  selectedOrganization: Organization;
  contactInfoState: any;
  // selectedOrganization: Organization;
  updateContactInfo: ActionData;
  readonly: boolean;
  onChangeGeneralInfoState: (value: any) => void;
  onChangeContactInfoState: (value: any) => void;
  onClose: () => void;
  onSubmit: (value: any, step: number, submitItem: boolean) => void;
}

const getSteps = () => {
  return ['General Info', 'Contact Info']
}

const getStepContent = (
  stepIndex: number,
  applicationType: string,
  generalInfoState: any,
  contactInfoState,
  // organizationBilling: OrganizationBilling,
  selectedOrganization,
  // organizationalInfoState,
  readonly,
  onSubmit: (values: any, step: number, submitItem: boolean) => void,
  handleNext: (values: any) => void,
  handleBack: (values: any) => void
) => {
  switch (stepIndex) {
    // case 0:
    //   return (
    //     <ApplyNewLocationModal addingProviderApplication={false} addProviderApplication={{
    //       loading: false,
    //       data: undefined,
    //       error: undefined,
    //       success: false
    //     }} show={true} onSubmit={function (values: any): void {
    //       throw new Error('Function not implemented.')
    //     }} />
    //   )
    case 0:
      return (
        <GeneralInfo
          activeStep={stepIndex}
          applicationType={applicationType}
          // organizationBilling={organizationBilling}
          selectedOrganization={selectedOrganization}
          initialValues={generalInfoState}
          readonly={readonly}
          handleNext={handleNext}
          onSubmit={(values: any) => onSubmit(values, stepIndex, false)}
        />
      )
    case 1:
      return (
        <ContactInfo
          initialValues={contactInfoState}
          readonly={readonly}
          handleNext={handleNext}
          handleBack={handleBack}
          onSubmit={(values: any, submitItem: boolean) => onSubmit(values, stepIndex, submitItem)}
        />
      )
    // case 2:
    //   return (
    //     <OrganizationalInfo
    //       initialValues={organizationalInfoState}
    //       readonly={readonly}
    //       handleNext={handleNext}
    //       handleBack={handleBack}
    //       onSubmit={(values: any) => onSubmit(values, stepIndex, false)}
    //     />
    //   )
    default:
      return 'Unknown Step'
  }
}

const LocationApplicationModal: FC<Props> =
  ({
    show,
    applicationType,
    updatingLocationApplicationForm,
    generalInfoState,
    updateGeneralInfo,
    contactInfoState,
    updateContactInfo,
    // organizationBilling,
    // organizationalInfoState,
    // updateOrgInfo,
    readonly,
    selectedOrganization,
    onChangeGeneralInfoState,
    onChangeContactInfoState,
    // onChangeOrganizationalInfoState,
    onClose,
    onSubmit
  }: Props) => {
    const [activeStep, setActiveStep] = useState(0)
    const steps = getSteps()

    const handleHide = () => {
      setActiveStep(0)
      onClose()
    }

    const handleNext = (values: any) => {
      if (activeStep === 0) {
        onChangeGeneralInfoState(values)
      } else if (activeStep === 1) {
        onChangeContactInfoState(values)
      }
      setActiveStep((prevActiveStep) => prevActiveStep + 1)
    }

    const handleBack = (values: any) => {
      if (activeStep === 1) {
        onChangeContactInfoState(values)
      }
      setActiveStep((prevActiveStep) => prevActiveStep - 1)
    }

    const loadingIcon = updateGeneralInfo.error !== false || updateContactInfo.error !== false ? <FontAwesomeIcon icon={['fas', 'exclamation-circle']} color={mainColors.loadingBlue} className='modal-success-icon' /> : <CircularProgress size={70} />
    const modalText = updateGeneralInfo.error !== false || updateContactInfo.error ? 'The data could not be saved.' : 'Updating Provider Application Form'
    const errorText = updateGeneralInfo.error && updateGeneralInfo.error !== false ? updateGeneralInfo.error.response.text :
      (updateContactInfo.error && updateContactInfo.error !== false ? updateContactInfo.error.response.text :
        ''
      )

    return (
      <Modal size='xl' backdrop='static' show={show} onHide={handleHide}>
        <Modal.Header closeButton id='modal-header'>
          <FontAwesomeIcon icon={['fas', 'edit']} size='lg' className='modal-header-icon' />
          <Modal.Title id='modal-header-title'>Provider Application</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {updatingLocationApplicationForm ? (
            updateGeneralInfo.loading || updateGeneralInfo.error !== false || updateContactInfo.loading || updateContactInfo.error !== false ? (
              // updateGeneralInfo.loading || updateGeneralInfo.error !== false || updateContactInfo.loading || updateContactInfo.error !== false || updateOrgInfo.loading || updateOrgInfo.error !== false ? (
              <div className='modal-loading-container'>
                {loadingIcon}
                <span className='modal-loading-text' style={updateContactInfo.error !== false ? { width: '100%' } : {}}>{modalText}</span>
                {
                  updateGeneralInfo.error !== false || updateContactInfo.error ? (<span style={{ width: '100%' }} dangerouslySetInnerHTML={{ __html: errorText }} />) : null
                }
              </div>
            ) : updateContactInfo.success || updateGeneralInfo.success ? (
              <div className='modal-success-container'>
                <FontAwesomeIcon icon={['far', 'check-circle']} color={mainColors.successGreen} className='modal-success-icon' />
                <span className='modal-loading-text'>Success!</span>
                <span className='modal-success-text'>You have {(updateContactInfo.data?.submitItem || updateGeneralInfo.data?.submitItem) === 'SUBMITTED' ? 'submitted' : 'updated'} your Provider Application Form.</span>
              </div>
            ) : (
              <div></div>
            )
          ) : (
            <div style={{ width: '100%' }}>
              <Stepper activeStep={activeStep} alternativeLabel>
                {
                  steps.map((label) => (
                    <Step key={label}>
                      <StepLabel>{label}</StepLabel>
                    </Step>
                  ))
                }
              </Stepper>
              {
                getStepContent(
                  activeStep,
                  applicationType,
                  // organizationBilling,
                  generalInfoState,
                  contactInfoState,
                  selectedOrganization,
                  // organizationalInfoState,
                  readonly,
                  onSubmit,
                  handleNext,
                  handleBack
                )
              }
            </div>
          )}
        </Modal.Body>
      </Modal>
    )
  }

export default LocationApplicationModal